export const de = {
  'ad.label': 'Werbung',
  'ad.sponsored_by': 'Gesponsert von {advertiser}',
  'ad.visit': 'Besuchen',
  'cookies.preferences': 'Cookie-Einstellungen',
  'cookies.title': 'Deine Privatsphäre, unter deiner Kontrolle',
  'cookies.description': 'Wir verwenden notwendigen Speicher, damit Albambam funktioniert. Analytik oder Marketing aktivieren wir nur mit deiner Erlaubnis. Du kannst sie jederzeit widerrufen. Lies die',
  'cookies.privacy_link': 'Datenschutzerklärung',
  'cookies.close': 'Einstellungen schließen',
  'cookies.necessary': 'Notwendige',
  'cookies.necessary_desc': 'Sitzung, Sicherheit, Sprache und Grundeinstellungen.',
  'cookies.analytics': 'Analytik',
  'cookies.analytics_desc': 'Anonyme Nutzungsmessung zur Verbesserung des Dienstes.',
  'cookies.marketing': 'Marketing',
  'cookies.marketing_desc': 'Personalisierte Werbung und Kampagnenmessung.',
  'cookies.configure': 'Konfigurieren',
  'cookies.reject': 'Optionale ablehnen',
  'cookies.save': 'Auswahl speichern',
  'cookies.accept': 'Alle akzeptieren',
  'lang.selector_label': 'Sprache',
  'lang.changed': 'Sprache geändert',
  'nav.home': 'Start',
  'nav.categories': 'Kategorien',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Freunde',
  'nav.upload': 'Hochladen',
  'nav.profile': 'Profil',
  'nav.login': 'Anmelden',
  'common.signed_in': 'Angemeldet',
  'common.error': 'Fehler',
  'topbar.search_placeholder': 'Videos, Creator suchen...',
  'legal.terms': 'Bedingungen',
  'legal.privacy': 'Datenschutz',
  'nav.admin': 'Verwaltung',
  'nav.logout': 'Abmelden',
  'admin.tab.payments': 'Zahlungen',
  'admin.payments.title': 'Zahlungen',
  'cats.title': 'Kategorien',
  'cats.all': 'Alle',
  'cats.adult_title': 'Kategorien +18',
  'cats.empty': 'Keine Videos in dieser Kategorie.',
  'friends.block_confirm': 'Diesen Freund blockieren? Ihr könnt dann nicht mehr chatten oder euch als Freunde sehen.',
  'friends.accepted': 'Ihr seid jetzt Freunde!',
  'friends.title': 'Freunde',
  'friends.subtitle': 'Nur wer sich gegenseitig folgt, wird Freund und kann privat chatten.',
  'friends.unread_count_label': '{n} ungelesene Nachrichten',
  'friends.blocked_users_title': 'Blockierte Nutzer',
  'friends.unblock_user': 'Entblockieren',
  'friends.requests_title': 'Chat-Anfragen',
  'friends.request_badge': 'Anfrage',
  'friends.request_accept': 'Annehmen',
  'friends.request_ignore': 'Ignorieren',
  'friends.empty_title': 'Du hast noch keine Freunde',
  'friends.empty_subtitle': 'Folge jemandem und lass dich zurückverfolgen, um den privaten Chat freizuschalten.',
  'friends.attach_image': 'Foto',
  'friends.shared_video_label': 'Hat ein Video geteilt',
  'friends.select_conversation': 'Wähle einen Freund, um zu chatten',
  'friends.block_user': 'Blockieren',
  'friends.no_messages_yet': 'Noch keine Nachrichten. Sag Hallo!',
  'friends.message_placeholder': 'Nachricht schreiben...',
  'section.trending': 'Trends',
  'section.shorts': 'Shorts',
  'section.for_you': 'Für dich',
  'home.hero.badge': 'Willkommen bei Albambam',
  'home.hero.title_1': 'Kurze Videos.',
  'home.hero.title_2': 'Echte Creator.',
  'home.hero.subtitle': 'Schauen, teilen und verdienen. Lade deine Videos hoch und entdecke neue Talente in jeder Kategorie.',
  'home.hero.cta_shorts': 'Shorts ansehen',
  'home.hero.cta_trending': 'Trends',
  'home.shorts.see_all': 'Alle ansehen',
  'home.empty.title': 'Noch keine Videos',
  'home.empty.subtitle': 'Wenn Creator Inhalte hochladen, erscheinen sie hier.',
  'live.send_diamonds': 'Diamanten senden',
  'live.buy': 'Kaufen',
  'live.chat': 'Chat',
  'live.type_message': 'Nachricht schreiben...',
  'live.send': 'Senden',
  'auth.success_google': 'Mit Google angemeldet',
  'auth.fail_google': 'Ungültige Google-Sitzung',
  'auth.success_login': 'Angemeldet',
  'auth.success_register': 'Konto erstellt',
  'auth.login_tab': 'Anmelden',
  'auth.register_tab': 'Konto erstellen',
  'auth.email': 'E-Mail',
  'auth.password': 'Passwort',
  'auth.submit_login_loading': 'Anmeldung...',
  'auth.submit_login': 'Anmelden',
  'auth.name': 'Name',
  'auth.submit_register_loading': 'Wird erstellt...',
  'auth.submit_register': 'Konto erstellen',
  'auth.or': 'oder',
  'legal.privacy_title': 'Datenschutzerklärung',
  'search.title': 'Ergebnisse für „{q}“',
  'search.count': '{n} Videos',
  'search.empty': 'Keine Ergebnisse.',
  'series.load_error': 'Die Serie konnte nicht geladen werden',
  'series.unlocked': 'Serie freigeschaltet',
  'series.purchase_error': 'Der Kauf konnte nicht gestartet werden',
  'series.restricted': 'Zugang beschränkt',
  'series.configure_access': 'Zugang konfigurieren',
  'series.language_all': 'Alle Sprachen',
  'series.episode_count': '{n} Episoden',
  'series.buy': 'Serie kaufen',
  'series.filter_language': 'Nach Sprache filtern',
  'series.no_episodes': 'Noch keine Episoden veröffentlicht.',
  'series.episode_number': 'Episode {n}',
  'legal.terms_title': 'Nutzungsbedingungen',
  'lang.ca': 'Katalanisch',
  'lang.en': 'Englisch',
  'lang.es': 'Spanisch',
  'lang.fr': 'Französisch',
  'lang.de': 'Deutsch',
  'lang.it': 'Italienisch',
  'lang.eu': 'Baskisch',
  'lang.gl': 'Galicisch',
  'lang.zh': 'Chinesisch',
  'lang.other': 'Andere',
  'lang.vi': 'Vietnamesisch',
  'lang.ja': 'Japanisch',
  'lang.ko': 'Koreanisch',
  'lang.ru': 'Russisch',
  'lang.ro': 'Rumänisch',
  'lang.ar': 'Arabisch',
  'lang.tr': 'Türkisch',
  'lang.pl': 'Polnisch',
  'lang.ms': 'Malaiisch',
  'lang.ta': 'Tamil',
  'upload.series_title_error': 'Gib den Titel der Serie ein',
  'upload.series_adult_category_error': 'Wähle eine Kategorie +18 für die Serie',
  'upload.series_created': 'Serie erstellt',
  'upload.series_create_error': 'Die Serie konnte nicht erstellt werden',
  'upload.err_file': 'Wähle eine gültige Videodatei',
  'upload.err_title': 'Gib einen Titel an',
  'upload.series_select_error': 'Wähle eine Serie aus oder erstelle eine',
  'upload.trailer_target_error': 'Wähle das Video oder die Serie des Trailers',
  'upload.price_error': 'Gib einen gültigen Preis von mindestens 0,50 EUR ein.',
  'upload.adult_category_error': 'Wähle eine Erwachsenenkategorie',
  'upload.success': 'Video erfolgreich hochgeladen',
  'upload.title_h': 'Video hochladen',
  'upload.kind': 'Art der Veröffentlichung',
  'upload.kind_video': 'Eigenständiges Video',
  'upload.kind_episode': 'Episode einer Serie',
  'upload.kind_trailer': 'Öffentlicher Trailer in Shorts',
  'upload.series': 'Serie',
  'upload.series_select': 'Serie auswählen',
  'upload.episode': 'Episode',
  'upload.series_new_title': 'Titel einer neuen Serie',
  'upload.series_create': 'Serie erstellen',
  'upload.series_adult': 'Serie +18',
  'upload.series_premium': 'Premium-Serie',
  'upload.series_adult_category': 'Kategorie +18 der Serie',
  'upload.series_price': 'Preis pro Episode und Paket (EUR)',
  'upload.trailer_for': 'Der Trailer zeigt',
  'upload.trailer_select': 'Video oder Serie auswählen',
  'upload.video_prefix': 'Video',
  'upload.file_label': 'Videodatei (MP4, max. 1GB)',
  'upload.file_pick': 'Klicken, um ein Video auszuwählen',
  'upload.thumb_label': 'Miniaturbild (optional)',
  'upload.video_title': 'Titel',
  'upload.description': 'Beschreibung',
  'upload.category': 'Kategorie',
  'upload.is_short': 'Ist ein Short (vertikal)',
  'upload.paid_video': 'Bezahlvideo',
  'upload.adult_content': 'Inhalt +18',
  'upload.video_language': 'Sprache des Videos',
  'upload.individual_price': 'Preis zum Ansehen dieses Videos (EUR)',
  'upload.paid_video_help': 'Der Zuschauer kauft dauerhaften Zugang nur zu diesem Video. Der Mindestpreis beträgt 0,50 EUR.',
  'upload.adult_category': 'Erwachsenenkategorie',
  'upload.uploading': 'Hochladen {n}%',
  'upload.submit': 'Video hochladen',
  'user.followers': 'Follower',
  'user.following': 'gefolgt',
  'user.follow': 'Folgen',
  'user.chat_open': 'Chatten',
  'user.request_sent': 'Anfrage gesendet',
  'user.send_message': 'Nachricht senden',
  'user.followers_title': 'Follower',
  'user.following_title': 'Gefolgt',
  'user.unfollow': 'Entfolgen',
  'user.request_title': 'Chat-Anfrage',
  'user.request_subtitle': 'Du kannst nur eine Nachricht senden. Nimmt die Person deine Anfrage an, werdet ihr Freunde und könnt chatten.',
  'user.request_placeholder': 'Schreibe deine Nachricht...',
  'user.request_send': 'Anfrage senden',
  'shorts.login_for_like': 'Melde dich an, um zu liken',
  'watch.share_copied': 'Link kopiert',
  'watch.delete_confirm': 'Diesen Kommentar löschen?',
  'ad.skip_in': 'Überspringen in {n}s',
  'ad.skip': 'Werbung überspringen',
  'watch.share': 'Teilen',
  'friends.share_video': 'Video teilen',
  'friends.send': 'Senden',
  'watch.comments': 'Kommentare',
  'watch.write_comment': 'Kommentar schreiben...',
  'watch.publish': 'Veröffentlichen',
  'watch.login_to_comment': 'Zum Kommentieren anmelden.',
  'watch.login_btn': 'Zum Kommentieren anmelden',
  'watch.no_comments': 'Noch keine Kommentare.',
  'watch.related': 'Ähnlich',
  'nav.trending': 'Trends',
  'friends.follow_option_only_follow': 'Folgen',
  'friends.follow_option_friends': 'Freunde',
  'watch.like': 'Gefällt mir',
  'watch.views_short': '{n} Aufrufe',
  'shorts.empty.title': 'Noch keine Shorts',
  'shorts.empty.subtitle': 'Lade ein kurzes Video hoch, um den Bereich zu eröffnen.',
  'shorts.share': 'Teilen',
  'auth.continue_google': 'Mit Google fortfahren',
  'upload.is_premium': 'Premium',
  'upload.price': 'Preis (€)',
  'upload.err_select': 'Wähle ein Video',
  'profile.upload_btn': 'Video hochladen',
  'profile.tab_videos': 'Meine Videos ({n})',
  'profile.tab_history': 'Verlauf',
  'profile.tab_recos': 'Empfehlungen',
  'profile.no_videos': 'Du hast noch keine Videos hochgeladen.',
  'profile.no_history': 'Du hast noch keine Videos angesehen.',
  'profile.no_recos': 'Sieh dir einige Videos an, um Empfehlungen zu erhalten.',
  'profile.likes': 'Gefällt-mir-Angaben',
  'profile.views': 'Aufrufe',
  'wallet.title': 'Wallet',
  'wallet.rate_label': 'Satz',
  'wallet.min_label': 'Mindestauszahlung',
  'wallet.amount_label': 'Auszuzahlender Betrag',
  'wallet.withdraw_btn': 'Auszahlung anfordern',
  'wallet.history_title': 'Verlauf der Anfragen',
  'wallet.success': 'Anfrage erstellt',
  'wallet.bad_amount': 'Ungültiger Betrag',
  'wallet.per_view': '{rate} {cur}/Aufruf',
  'admin.title': 'Verwaltung',
  'admin.stats.users': 'Nutzer',
  'admin.stats.videos': 'Videos',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'Aufrufe',
  'admin.tab.videos': 'Videos',
  'admin.tab.ads': 'Anzeigen',
  'admin.tab.users': 'Nutzer',
  'admin.tab.withdrawals': 'Auszahlungen',
  'admin.tab.config': 'Einstellungen',
  'admin.tab.translations': 'Sprachen',
  'tbl.title': 'Titel',
  'tbl.creator': 'Ersteller',
  'tbl.category': 'Kategorie',
  'tbl.type': 'Typ',
  'tbl.views': 'Aufrufe',
  'tbl.likes': 'Likes',
  'tbl.status': 'Status',
  'tbl.actions': 'Aktionen',
  'tbl.placement': 'Platzierung',
  'tbl.advertiser': 'Werbetreibender',
  'tbl.impressions': 'Imp.',
  'tbl.clicks': 'Klicks',
  'tbl.active': 'Aktiv',
  'tbl.name': 'Name',
  'tbl.email': 'E-Mail',
  'tbl.role': 'Rolle',
  'tbl.wallet': 'Wallet',
  'tbl.amount': 'Betrag',
  'tbl.date': 'Datum',
  'tbl.user': 'Nutzer',
  'video.video': 'Video',
  'video.short': 'Short',
  'action.show': 'Veröffentlichen',
  'action.hide': 'Ausblenden',
  'action.delete_confirm_video': 'Video löschen?',
  'ad.create_h': 'Anzeige erstellen',
  'ad.title_label': 'Titel',
  'ad.image_label': 'Bild-URL',
  'ad.target_label': 'Ziel-URL',
  'ad.advertiser_label': 'Werbetreibender',
  'ad.placement_label': 'Platzierung',
  'ad.placement.banner': 'Banner (Website)',
  'ad.placement.preroll': 'Pre-roll (vor dem Video)',
  'ad.placement.overlay': 'Overlay (im Video)',
  'ad.active': 'Aktiv',
  'ad.create_btn': 'Erstellen',
  'ad.success_create': 'Anzeige erstellt',
  'ad.delete_confirm': 'Anzeige löschen?',
  'users.make_admin': 'Zum Admin machen',
  'users.remove_admin': 'Admin entfernen',
  'wd.approve': 'Genehmigen',
  'wd.reject': 'Ablehnen',
  'wd.mark_paid': 'Als bezahlt markieren',
  'wd.empty': 'Keine Anfragen',
  'cfg.title': 'Zahlungseinstellungen',
  'cfg.rate_label': 'Zahlung pro Aufruf ({cur})',
  'cfg.min_label': 'Mindestauszahlung ({cur})',
  'cfg.currency': 'Währung',
  'cfg.save': 'Speichern',
  'cfg.saved': 'Einstellungen gespeichert',
  'trans.title': 'Sprachen und Übersetzungen',
  'trans.intro': 'Lade eine JSON-Datei mit Übersetzungen für einen beliebigen Sprachcode hoch (z. B. ja, pt, zh). Die Datei muss eine flache Zuordnung Schlüssel → Text enthalten.',
  'trans.code_label': 'Sprachcode (z. B. ja, pt-BR, zh)',
  'trans.name_label': 'Name (in dieser Sprache)',
  'trans.file_label': 'JSON-Datei mit Übersetzungen',
  'trans.upload': 'Hochladen',
  'trans.uploaded': 'Übersetzungen gespeichert',
  'trans.delete': 'Löschen',
  'trans.delete_confirm': 'Diese Sprache löschen?',
  'trans.builtin': 'Integriert',
  'trans.custom': 'Benutzerdefiniert',
  'trans.empty_custom': 'Noch keine benutzerdefinierten Sprachen.',
  'common.cancel': 'Abbrechen',
  'common.loading': 'Wird geladen...',
  'common.too_fast': 'Zu schnell, bitte kurz warten',
  'time.few_seconds': 'vor wenigen Sekunden',
  'time.min': 'vor {n} Min.',
  'time.h': 'vor {n} Std.',
  'time.d': 'vor {n} T.',
  'time.w': 'vor {n} Wo.',
  'time.mo': 'vor {n} Mon.',
  'time.y': 'vor {n} J.',
  'brand.tagline': 'Kurze Videos. Echte Creator.',
  'live.section': 'Live',
  'live.start': 'Live starten',
  'live.end': 'Live beenden',
  'live.join': 'Live beitreten',
  'live.chat_placeholder': 'Nachricht schreiben...',
  'live.diamond': 'Diamant',
  'live.buy_access': 'Zugang kaufen',
  'live.save_recording': 'Aufnahme speichern',
};
